/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaptureSettings
 */
export interface CaptureSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CaptureSettings
     */
    isLongRange: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaptureSettings
     */
    detectVehicles: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaptureSettings
     */
    upsideDown: boolean;
}

export function CaptureSettingsFromJSON(json: any): CaptureSettings {
    return CaptureSettingsFromJSONTyped(json, false);
}

export function CaptureSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isLongRange': json['is_long_range'],
        'detectVehicles': json['detect_vehicles'],
        'upsideDown': json['upside_down'],
    };
}

export function CaptureSettingsToJSON(value?: CaptureSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_long_range': value.isLongRange,
        'detect_vehicles': value.detectVehicles,
        'upside_down': value.upsideDown,
    };
}

